<section [ngClass]="dynamicClass">
  <app-hero-internal *ngIf="CardData?.Image?.value?.src" [data]="CardData"></app-hero-internal>
  <app-breadcrumb *ngIf="breadcrumbData" [data]="breadcrumbData"></app-breadcrumb>

  <!-- Banner-Image-List START -->
  <section *ngIf="CardData?.FaceCardImage?.value?.src" class="pb-container">
    <div class="pb-flex pb-flex-col pb-gap-5 lg:pb-gap-6 lg:pb-flex-row-reverse">
      <div *ngIf="CardData?.FaceCardImage?.value?.src" class="lg:pb-w-1/2">
        <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="CardData?.FaceCardImage?.value?.src" *ngIf="!isMobile && !energySave" 
          alt="{{CardData?.FaceCardImage?.value?.alt}}" class="pb-aspect-[4/3] pb-object-cover" />
        <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="CardData?.FaceCardImage?.value?.src" *ngIf="isMobile && !energySave"
          alt="{{CardData?.FaceCardImage?.value?.alt}}" class="pb-h-full pb-object-cover" />
        <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="CardData?.FaceCardImageGreen ?.value?.src" *ngIf="!isMobile && energySave" 
          alt="{{CardData?.FaceCardImageGreen ?.value?.alt}}" class="pb-aspect-[4/3] pb-object-cover pb-energy-illustration" />
        <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="CardData?.FaceCardImageGreen ?.value?.src" *ngIf="isMobile && energySave"
          alt="{{CardData?.FaceCardImageGreen ?.value?.alt}}" class="pb-h-full pb-object-cover pb-energy-illustration" />
      </div>
      <div class="pb-flex pb-flex-col lg:pb-gap-8 pb-w-full lg:pb-w-1/2">
        <h2 *ngIf="CardData?.DescriptionTitle?.value" class="pb-text-d-md-m lg:pb-text-d-md pb-font-serif">
          {{CardData?.DescriptionTitle?.value}}
        </h2>
        <div *ngIf="CardData?.ShortDescription?.value" class="pb-text-md-m lg:pb-text-lg"
          [innerHTML]="CardData?.ShortDescription?.value"></div>
        <div *ngIf="CardData?.KeyFeatures?.value"
          class="pb-flex pb-flex-col pb-gap-5 pb-icon-list pb-mt-7 lg:pb-mt-0"
          [innerHTML]="CardData?.KeyFeatures?.value">
        </div>
      </div>
    </div>
  </section>
  <!-- Banner-Image-List END -->
  <!-- TextBlock -->
  <section *ngIf="!CardData?.FaceCardImage?.value?.src" class="pb-container">
    <div class="pb-flex pb-flex-col lg:pb-flex-row pb-gap-6">
      <div class="lg:pb-w-7/12">
        <div class="pb-text-md-m lg:pb-text-lg lg:pb-w-5/6" [innerHTML]="CardData?.ShortDescription?.value"></div>
        <div *ngIf="CardData?.Link?.value?.href || CardData?.SecondaryLink?.value?.href" class="pb-flex pb-flex-col">
          <a *ngIf="CardData?.Link?.value?.href" hybridHref hreflang="{{language}}" href="{{CardData?.Link?.value?.href}}"
            target="{{CardData?.Link?.value?.target}}" class="pb-mt-4 md:pb-w-fit">{{CardData?.Link?.value?.text}}</a>
          <a *ngIf="CardData?.SecondaryLink?.value?.href" hybridHref hreflang="{{language}}" href="{{CardData?.SecondaryLink?.value?.href}}"
            target="{{CardData?.SecondaryLink?.value?.target}}"
            class="pb-mt-4 md:pb-w-fit">{{CardData?.SecondaryLink?.value?.text}}</a>
        </div>
      </div>
      <div class="pb-flex pb-flex-col pb-gap-4 lg:pb-gap-5 pb-w-full lg:pb-w-5/12 pb-icon-list"
        *scRichText="CardData?.KeyFeatures"></div>
    </div>
    <!-- TextBlock-END -->
  </section>
  <div class="pb-container pb-mt-8">
    <a *ngIf="CardData?.AnchorId?.value" pageScroll [pageScrollOffset]="120" [pageScrollDuration]="1000"
      href="#{{CardData?.AnchorId?.value}}" attr.aria-label="{{CardData?.AnchorId?.value}}"
      class="items-center pb-flex pb-w-fit pb-mt-5 lg:pb-mt-0 pb-cursor-pointer">
      <span
        class="pb-link pb-font-bold">{{CardData?.AnchorTo?.value}}</span>
    </a>
    <a *ngIf="rendering.fields?.ModalText?.value && hasModal" href="#ContactForm" aria-label="Open contact form"
      (click)="openModal($event)"
      class="pb-link pb-font-bold">{{rendering.fields?.ModalText?.value}}</a>
  </div>

</section>